export default __webpack_public_path__ + "static/media/eazyask-highlight-a-response.0c5fbb7d.gif";